import Vue from 'vue'

const requireDirective = require.context('./modules', true, /\.js$/)
// 自定义指令
let directives = {}
requireDirective.keys().map((file) => {
  // console.log('file', file)
  const name = removerLastIndex(file)
  if (name) {
    directives = {
      ...directives,
      [name]: requireDirective(file).default
    }
  }
 
  return false
})
function removerLastIndex (str) {
  const start = str.substring(2, str.length) // 去除路径中的./ start=el-drag-dialog/index.js
  // str = login/index
  // 获取最后一个/的索引
  const index = start.lastIndexOf('/')
  // 获取最后一个/后面的值
  const val = start.substring(index + 1, start.length)
  // 判断是不是index结尾
  if (val === 'index.js') {
    return start.substring(index, -1)
  }
  return str
}
 
export default {
  install (Vue) {
    Object.keys(directives).forEach((key) => {
      console.log('directives[key]', key, directives[key])
      Vue.directive(key, directives[key])
    })
  }
}
